// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-prompt {
    display: none;
}

.show-disabled > .disabled-prompt {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 40px;
    display: block;
    font-size: 22px;
    padding: 5px 10px;
    color: #FFF;
    font-weight: bold;
    z-index: 9999;
    box-shadow:1px 1px 1px #000;
    text-shadow:1px 1px 1px #333;

    background: #666; /* For browsers that do not support gradients */
    background: -webkit-linear-gradient(#ccc, #666); /* For Safari 5.1 to 6.0 */
    background: -o-linear-gradient(#ccc, #666); /* For Opera 11.1 to 12.0 */
    background: -moz-linear-gradient(#ccc, #666); /* For Firefox 3.6 to 15 */
    background: linear-gradient(#ccc #666); /* Standard syntax */
    
    animation-name: prompt;
    animation-duration: 2s;
    animation-timing-function: ease-in-out;
}

@keyframes prompt {
    0% { opacity: 0; top: -40px; }
    20% { opacity: 1; top: 0px; }
    80% { opacity: 1; top: 0px; }
    100% { opacity: 0; top: -40px; }
}`, "",{"version":3,"sources":["webpack://./src/components/BCMSDisabledPrompt/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,2BAA2B;IAC3B,4BAA4B;;IAE5B,gBAAgB,EAAE,+CAA+C;IACjE,+CAA+C,EAAE,0BAA0B;IAC3E,0CAA0C,EAAE,2BAA2B;IACvE,4CAA4C,EAAE,0BAA0B;IACxE,sCAAsC,EAAE,oBAAoB;;IAE5D,sBAAsB;IACtB,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,KAAK,UAAU,EAAE,UAAU,EAAE;IAC7B,MAAM,UAAU,EAAE,QAAQ,EAAE;IAC5B,MAAM,UAAU,EAAE,QAAQ,EAAE;IAC5B,OAAO,UAAU,EAAE,UAAU,EAAE;AACnC","sourcesContent":[".disabled-prompt {\n    display: none;\n}\n\n.show-disabled > .disabled-prompt {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 40px;\n    display: block;\n    font-size: 22px;\n    padding: 5px 10px;\n    color: #FFF;\n    font-weight: bold;\n    z-index: 9999;\n    box-shadow:1px 1px 1px #000;\n    text-shadow:1px 1px 1px #333;\n\n    background: #666; /* For browsers that do not support gradients */\n    background: -webkit-linear-gradient(#ccc, #666); /* For Safari 5.1 to 6.0 */\n    background: -o-linear-gradient(#ccc, #666); /* For Opera 11.1 to 12.0 */\n    background: -moz-linear-gradient(#ccc, #666); /* For Firefox 3.6 to 15 */\n    background: linear-gradient(#ccc #666); /* Standard syntax */\n    \n    animation-name: prompt;\n    animation-duration: 2s;\n    animation-timing-function: ease-in-out;\n}\n\n@keyframes prompt {\n    0% { opacity: 0; top: -40px; }\n    20% { opacity: 1; top: 0px; }\n    80% { opacity: 1; top: 0px; }\n    100% { opacity: 0; top: -40px; }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
